import styled from "styled-components";

import { theme } from "../../../../styles/theme";

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
`;

export const CardContent = styled.div`
  // form inputs
  input {
    width: 100% !important;
  }
  
  width: 90%;
  height: 85%;
  background-color: ${theme.colors.darkBlue};
  border-radius: 20px;
  padding: 30px 60px 30px 60px;
  margin: 0 auto;
  overflow: auto;

  ::-webkit-scrollbar {
    width: 8px !important;
  }

  ::-webkit-scrollbar-track {
    background-color: ${theme.colors.blue800} !important;
  }

  ::-webkit-scrollbar-thumb {
    background: ${theme.colors.gray800} !important;
    border-radius: 0 !important;
  }

  @media screen and (max-width: 479px) {
    width: 100%;
    padding: 10px;
  }
`;


export const EditButton = styled.button`
  background-color: ${theme.colors.blue400};
  color: ${theme.colors.white};
  border: none;
  border-radius: .5rem;
  padding: 0.750rem 1rem;
  font-size: 1rem;
  cursor: pointer;

  &:hover {
    background-color: ${theme.colors.blue400};
  }

  display: flex;
  gap: 0.5rem;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 90%;
  margin: 0 auto;
  margin-bottom: 20px;
`;